import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import Chart from '../chart'
import Table from '../table'
import DataLayout from '../data-layout'

const RevenueByLineNo = ({
  match: {
    params: { year, lineNo }
  },
  location
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(`/GetRevenue/${year}/${lineNo}`)
      const _data = result.data.map(d => ({
        name: d.Description.trim(),
        nameColumn: 'Revenue Category',
        nameClick: `/revenue/${year}/${lineNo}/${d.ObjectCode}${
          location.search
        }&objDesc=${d.Description.trim()}`,
        data: d.Amount
      }))
      setData(_data.sort((a, b) => b.data - a.data))
    }

    loadData()
  }, [lineNo, location.search, year])

  return (
    <DataLayout year={year}>
      <Chart data={data} />
      <Table
        data={{
          headers: [
            {
              title: 'Revenue Category',
              dataKey: 'name',
              clickThrough: 'nameClick'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data
        }}
      />
    </DataLayout>
  )
}

export default RevenueByLineNo
